import React, { useEffect, useState } from "react";
import SettingComponent from "./setting";
import "./setting.scss";
import { userAuthentication } from "../../../redux/slice/userAuthenticationSlice";
import { connect } from "react-redux";
import { userResetPin } from "../../../redux/slice/userResetPinSlice";
import Notify from "../common/notify/notify";
import PageLoader from "../common/pageLoader";
import { Cookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

const Setting = (props) => {
  const {
    calluserAuthenticationData,
    userAuthenticationData,
    calluserResetPinData,
    userResetPinData,
  } = props;
  const adminDetails =
    (userAuthenticationData &&
      userAuthenticationData.userAuthenticationData &&
      userAuthenticationData.userAuthenticationData.data &&
      userAuthenticationData.userAuthenticationData.data.data) ||
    null;
  const cookies = new Cookies();
  const navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [formValues, setFormValues] = useState({
    currentpassword: "",
    newpassword: "",
  });
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    calluserAuthenticationData();
  }, []);

  const handelModalOpen = () => {
    setConfirmModal(true);
  };

  const handleCancelModal = () => {
    setConfirmModal(false);
    setFormValues({
      currentpassword: "",
      newpassword: "",
    });
    setFormErrors({});
  };

  const handleInputChange = (event) => {
    setFormValues((prevState) => ({
      ...prevState,
      currentpassword: event,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      currentpassword: "",
    }));
  };
  const handleNewChangePin = (event) => {
    setFormValues((prevState) => ({
      ...prevState,
      newpassword: event,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      newpassword: "",
    }));
  };

  const handleEditDetails = async () => {
    const errors = {};
    if (!formValues.currentpassword) {
      errors.currentpassword = "Please Enter Current PIN";
    }
    if (!formValues.newpassword) {
      errors.newpassword = "Please Enter New PIN";
    }
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      const userData = {
        phone_number: adminDetails.phone_number,
        old_code: Number(formValues.currentpassword),
        new_code: Number(formValues.newpassword),
      };
      const response = await calluserResetPinData(userData);
      if (response.type === "userResetPin/fulfilled") {
        setConfirmModal(false);
        setFormValues({
          currentpassword: "",
          newpassword: "",
        });
        Notify("success", response.payload.message, "");
      } else {
        if (response.error && response.error.message) {
          Notify("error", response.error.message, "");
        }
      }
    }
  };
  const handleLogOutScreen = () => {
    setOpenModal(true);
  };
  const handleConfirmLogOutScreen = () => {
    cookies.remove("token", { path: "/" });
    cookies.remove("role", { path: "/" });
    cookies.remove("societyId", { path: "/" });
    cookies.remove("society_id", { path: "/" });
    cookies.remove("society_name", { path: "/" });

    setIsLoggedIn(false);
    navigate("/");
    window.location.reload();
  };

  const loading =
    userAuthenticationData.isLoading || userResetPinData.isLoading;
  const spinLoader = userResetPinData.isLoading;
  return (
    <>
      {loading && <PageLoader />}
      <SettingComponent
        handelModalOpen={handelModalOpen}
        confirmModal={confirmModal}
        handleCancelModal={handleCancelModal}
        handleInputChange={handleInputChange}
        handleEditDetails={handleEditDetails}
        formValues={formValues}
        formErrors={formErrors}
        adminDetails={adminDetails}
        handleLogOutScreen={handleLogOutScreen}
        spinLoader={spinLoader}
        handleNewChangePin={handleNewChangePin}
        handleConfirmLogOutScreen={handleConfirmLogOutScreen}
        setOpenModal={setOpenModal}
        openModal={openModal}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userAuthenticationData: state.userAuthenticationData,
    userResetPinData: state.userResetPinData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    calluserAuthenticationData: () => dispatch(userAuthentication()),
    calluserResetPinData: (data) => dispatch(userResetPin(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Setting);
